module.exports = __webpack_public_path__ + "img/cost-icon__mini_market.28ac3598.svg";